import { Component, Input, Output, EventEmitter, TemplateRef, SimpleChanges } from '@angular/core';
import { PeakSales } from '../pharma-page.model';

@Component({
  selector: 'app-peak-sales-filter',
  templateUrl: './peak-sales-filter.component.html',
  styleUrls: ['./peak-sales-filter.component.scss']
})
export class PeakSalesFilterComponent {
  // @Input() panel;
  @Input() activePanel = "";
  @Input() refreshCurrentPanel = false;
  @Input() panel = {} as any;
  // @Input() facetData = {};
  // @Input() cachedSelections = {};
  // @Input() facetFilter ={};

  @Input() loading: boolean;
  @Input() facetFilter: any;
  @Input() data: PeakSales;
  @Input() amountFormatter: TemplateRef<any>;
  @Output() onChange: EventEmitter<any> = new EventEmitter();
  customSkeletonConfig = {
    skeletonType: "list",
    config: {
      list: {
        noOfListItems: 8,
      },
    },
  };

  ngOnChanges(changes: SimpleChanges) {
    console.log(changes);
    if(changes?.facetFilter?.currentValue) {
      if (typeof this.facetFilter.include_max_sale === 'undefined') {
        this.facetFilter.include_max_sale = true;
      }
    }
  }

  onMaxSaleChange(val) {
    let payload = {...this.facetFilter, include_max_sale: val };
    this.onChange.emit(payload);
  }

  onPeakSalesChange(obj) {
    let payload = {
      sale_selected_min: obj.min,
      sale_selected_max: obj.max,
      year_selected_min: this.facetFilter.year_selected_min,
      year_selected_max: this.facetFilter.year_selected_max,
      include_max_sale: this.facetFilter.include_max_sale
     };
    this.onChange.emit(payload);
    console.log(obj);
  }

  onPeakYearChange(obj) {
    let payload = {
      year_selected_min: obj.min,
      year_selected_max: obj.max,
      sale_selected_min: this.facetFilter.sale_selected_min,
      sale_selected_max: this.facetFilter.sale_selected_max,
      include_max_sale: this.facetFilter.include_max_sale
    };
    this.onChange.emit(payload);
    console.log(obj);
  }

  // dataExists(data) {
  //   return data && Object.keys(data).length;
  // }
}
